/**
 * Mapping of screen names to their corresponding page names.
 * @type {object}
 */
const paths = {
  auth: {
    login: '/login',
    register: '/register',
    forgetPassword: '/forgot-password',
    afterLogin: '/fill-your-information',
    selectProfession: '/select-profession',
  },
  content: {
    genioChat: '/genio-chat',
    logout: '/logout',
    tabs: '/tabs',
  },
  shared: {
    notFound: '*',
  },
};

export default paths;
